export const de = {
  // Header
  header: {
    title: "Einfacher und schneller Stimmersatz in Ihrem Video, in jeder Sprache!",
    subtitle: "🔥Zahlen Sie nur für Ergebnisse – nur $0.099 pro Sekunde.🔥"
  },

  // Steps
  steps: {
    uploadVideo: "Video Hochladen",
    selectLanguages: "Sprachen Auswählen", 
    conversionResult: "Konvertierung und Ergebnis"
  },

  // Upload section
  upload: {
    dragAndDrop: "Ziehen Sie Ihre Videodatei hierher",
    orClickToSelect: "oder klicken Sie zum Auswählen",
    supportedFormats: "Unterstützte Formate: MP4, AVI, MOV, MKV, WebM",
    maxFileSize: "• Maximale Dateigröße: 250 MB",
    maxDuration: "• Maximale Dauer: 15 Min",
    processingTime: "• Verarbeitung dauert 2 bis 15 Minuten je nach Videoauflösung",
    chooseFile: "Datei Wählen",
    selectedFile: "Ausgewählte Datei:",
    size: "Größe:",
    fileTypeError: "Bitte wählen Sie eine Videodatei",
    fileSizeError: "Dateigröße ({size} MB) überschreitet das Maximum von 250 MB",
    durationError: "Videodauer ({duration} Minuten) überschreitet das Maximum von 15 Minuten",
    fileReadError: "Videodatei kann nicht gelesen werden. Bitte versuchen Sie eine andere Datei."
  },

  // Language selection
  languages: {
    sourceAudioLanguage: "Quell-Audiosprache",
    targetAudioLanguage: "Ziel-Audiosprache",
    selectLanguage: "Sprache auswählen..."
  },

  // Language options
  languageOptions: {
    ru: "Russisch",
    en: "Englisch",
    es: "Spanisch",
    fr: "Französisch",
    de: "Deutsch",
    it: "Italienisch",
    pt: "Portugiesisch",
    pl: "Polnisch",
    zh: "Chinesisch",
    ja: "Japanisch",
    ko: "Koreanisch",
    bg: "Bulgarisch",
    hr: "Kroatisch",
    cs: "Tschechisch",
    da: "Dänisch",
    nl: "Niederländisch",
    et: "Estnisch",
    fi: "Finnisch",
    el: "Griechisch",
    hu: "Ungarisch",
    ga: "Irisch",
    lv: "Lettisch",
    lt: "Litauisch",
    mt: "Maltesisch",
    ro: "Rumänisch",
    sk: "Slowakisch",
    sl: "Slowenisch",
    sv: "Schwedisch"
  },

  // Conversion
  conversion: {
    replaceAudio: "Audio Ersetzen",
    uploadVideoAndSelectLanguages: "Laden Sie ein Video hoch und wählen Sie Sprachen zum Fortfahren",
    fixValidationError: "Bitte beheben Sie den Dateifehler oben",
    createSubtitles: "Untertitel erstellen",
    uploadVideoForSubtitles: "Laden Sie ein Video hoch, um Untertitel zu erstellen",
    selectTranslationLanguage: "Übersetzungssprache auswählen"
  },

  // Demo video section
  demo: {
    seeVeviInAction: "VEVI in Aktion Sehen",
    watchHowItWorks: "Sehen Sie, wie unsere KI-Stimmersatz-Technologie funktioniert",
    beforeEnglish: "Vorher (Englisch)",
    originalPresentation: "Original Unternehmenspräsentation",
    afterSpanish: "Nachher (Spanisch,Französisch, Chinesisch, Italienisch)",
    aiTranslatedVoice: "KI-übersetzt mit natürlicher Stimme",
    demoTitle: "Demo - VEVI in Aktion"
  },

  // Reviews
  reviews: {
    title: "Was Unsere Kunden Sagen",
    subtitle: "Vertraut von Marketing-Profis weltweit",
    customerReviews: [
      {
        name: "Sarah Johnson",
        position: "Digital Marketing Manager",
        company: "TechFlow Solutions",
        text: "VEVI hat unsere internationalen Marketing-Kampagnen transformiert! Wir haben unsere Produktdemo-Videos für 8 verschiedene Märkte an nur einem Tag lokalisiert. Die Qualität ist unglaublich und die Preisgestaltung so transparent."
      },
      {
        name: "Michael Chen",
        position: "Content Marketing Direktor", 
        company: "GlobalReach Media",
        text: "Als jemand, der Videoinhalte für mehrere Regionen verwaltet, ist VEVI ein Wendepunkt. Der Stimmersatz ist so natürlich, dass unser Publikum nicht erkennen kann, dass es KI-generiert ist. Sehr empfehlenswert!"
      },
      {
        name: "Emma Rodriguez",
        position: "Brand Marketing Spezialistin",
        company: "InnovateCorp",
        text: "Wir sparten Tausende bei Voice-Over-Kosten während der Expansion in neue Märkte. Der Preis von $0.0314 pro Sekunde ist unglaublich fair, und die Ergebnisse sprechen für sich. Unsere Conversion-Raten stiegen um 40%!"
      },
      {
        name: "David Thompson",
        position: "Marketing Kampagnen Manager",
        company: "NextGen Brands",
        text: "Die Geschwindigkeit und Qualität von VEVI ist unübertroffen. Wir gingen von einem englischen Video zu 12 lokalisierten Versionen in verschiedenen Sprachen innerhalb von Stunden. Dieses Tool ist essentiell für globales Marketing."
      },
      {
        name: "Lisa Park",
        position: "Social Media Marketing Lead",
        company: "CreativeEdge Agency",
        text: "VEVI machte es möglich für unsere kleine Agentur, mehrsprachige Video-Services für Kunden anzubieten. Die Qualität ist professionell und der Prozess unglaublich einfach. Unsere Kunden lieben die Ergebnisse!"
      },
      {
        name: "James Wilson",
        position: "Performance Marketing Direktor",
        company: "ScaleUp Ventures",
        text: "ROI ist alles im Performance Marketing, und VEVI liefert. Wir reduzierten unsere Video-Lokalisierungskosten um 80% und verbesserten die Bearbeitungszeit von Wochen zu Stunden. Dieses Tool zahlt sich sofort aus."
      }
    ]
  },

  // Payment dialog
  payment: {
    title: "Konvertierungszahlung",
    processingCost: "Verarbeitungskosten",
    duration: "Dauer:",
    baseCost: "Grundkosten",
    discount: "Rabatt ({promoCode}):",
    discountAmount: "Rabattbetrag:",
    total: "Gesamt:",
    emailToReceiveResult: "E-Mail zum Erhalt des Ergebnisses",
    emailPlaceholder: "ihre-email@beispiel.de",
    promoCode: "🎟️ Promo-Code (optional)",
    promoCodePlaceholder: "Promo-Code eingeben",
    check: "Prüfen",
    checking: "Prüfung...",
    addSubtitles: "Untertitel zum Video hinzufügen",
    addSubtitlesDescription: "Untertitel in der Zielsprache generieren und einbetten",
    highQualityTranslation: "• Hochwertige KI-Übersetzung",
    originalVideoPreserved: "• Original-Video bewahrt",
    fastProcessing: "• Schnelle Verarbeitung (typisch 5-10 Minuten)",
    resultWillBeSent: "• Ergebnis wird an angegebene E-Mail gesendet",
    cancel: "Abbrechen",
    continue: "Fortfahren",
    enterEmail: "Bitte geben Sie Ihre E-Mail ein",
    enterValidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    enterPromoCode: "Bitte geben Sie einen Promo-Code ein",
    invalidPromoCode: "Ungültiger Promo-Code",
    validPromoCode: "Gültiger Promo-Code! {discount}% Rabatt angewendet"
  },

  // Progress dialog
  progress: {
    title: "Video Verarbeitung",
    uploadingAndExtracting: "🎬 Hochladen und Audio extrahieren",
    transcribingAndTranslating: "🗣️ Sprache transkribieren und übersetzen", 
    synthesizingAudio: "🎵 Neue Audiospur synthetisieren",
    step: "Schritt:",
    error: "Fehler"
  },

  // Result dialog
  result: {
    title: "Fertig! Ihr Video wurde verarbeitet",
    conversionCompleted: "Konvertierung erfolgreich abgeschlossen!",
    processedVideoDescription: "🎬 Ihr verarbeitetes Video mit Stimm-Kloning",
    payAndDownload: "Bezahlen und Herunterladen",
    videoNotAvailable: "Video nicht verfügbar",
    useDownloadButton: "Bitte verwenden Sie den Download-Button unten",
    downloadError: "Download-Fehler"
  },

  // Email sent dialog
  emailSent: {
    title: "Video Gesendet! 🎉",
    videoOnWay: "Das Video ist bereits auf dem Weg zu Ihrer E-Mail 🙏❤️",
    checkInbox: "Prüfen Sie Ihren Posteingang und Spam-Ordner. Das verarbeitete Video wird bald ankommen!",
    whatsNext: "Was kommt als nächstes?",
    checkEmail: "• Prüfen Sie Ihre E-Mail ({email})",
    checkSpam: "• Schauen Sie im Spam/Junk-Ordner nach, falls nicht gefunden",
    downloadAndEnjoy: "• Laden Sie herunter und genießen Sie Ihr synchronisiertes Video!",
    close: "Schließen",
    processAnotherVideo: "Anderes Video Verarbeiten"
  },

  // Processing steps
  processingSteps: {
    uploading: "Video hochladen...",
    extracting: "Audio extrahieren...",
    transcribing: "Sprache transkribieren...",
    translating: "Inhalt übersetzen...",
    synthesizing: "Neue Stimme synthetisieren...",
    rendering: "Finales Video rendern...",
    complete: "Verarbeitung abgeschlossen!"
  },

  // Common
  common: {
    minutes: "Minuten",
    seconds: "Sekunden",
    loading: "Laden...",
    error: "Fehler",
    success: "Erfolg"
  },

  // Social media
  socialMedia: {
    title: "Bleiben Sie verbunden",
    description: "Erhalten Sie die neuesten Updates zur KI-Stimmersatz-Technologie"
  },

  // Services (for Footer)
  services: {
    dubbing: "Synchronisation",
    voiceClone: "Synchronisation mit Stimmklonen",
    newVoice: "Synchronisation mit neuer Stimme",
    multilingual: "Mehrsprachige Synchronisation",
    multiSpeaker: "Multi-Sprecher-Synchronisation",
    subtitles: "Untertitel",
    subtitlesOnly: "Nur Untertitel",
    multilingualSubtitles: "Mehrsprachige Untertitel",
    subtitlesDescription: "Generieren Sie automatisch genaue Untertitel für jede Plattform.",
    subtitlesPrice: "Bearbeitungskosten: $0.01/Sek.",
    addSubtitles: "Untertitel hinzufügen",
    needsTranslation: "Übersetzung benötigt?",
    translationLanguage: "Übersetzungssprache"
  },

  // Footer
  footer: {
    legal: "Rechtliches",
    privacyPolicy: "Datenschutzerklärung",
    termsOfUse: "Nutzungsbedingungen"
  },

  // Navigation
  nav: {
    blog: "Blog"
  },

  // Blog
  blog: {
    title: "VEVI Monster Blog",
    subtitle: "Geschichte und Mythologie des VEVI-Universums",
    readMore: "Weiterlesen",
    backToBlog: "Zurück zum Blog",
    articleNotFound: "Artikel nicht gefunden",
    characteristics: "Eigenschaften",
    articles: {
      "vevi-monster": {
        title: "VEVI Monster",
        excerpt: "Vevi ist ein Wesen, das aus den Plasmawirbeln von Zera-13b geboren wurde. Er ist weder Fleisch noch Metall—sein Körper besteht aus vibrierenden Teilchen, die von einem elektromagnetischen Feld zusammengehalten werden.",
        metadata: {
          "Galaxie": "MoM-z14",
          "Alter": "13,4 Milliarden Jahre",
          "Typ": "Gesteinsplanet mit dichter Atmosphäre aus Methan und Neon",
          "Stern": "Roter Protostern Zera-13",
          "Umlaufbahn": "Zweiter Planet im System",
        },
        content: [
          "🌑 Beschreibung",
          "Zera-13b ist eine uralte und fast vergessene Welt, geboren in einer Ära, als das Universum gerade lernte zu leuchten.",
          "Sein Himmel schimmert mit matten grünen Flammen, und die dichte Atmosphäre zittert vor Neonstürmen. Die Oberfläche ist eine schwarz-graue Landschaft, bedeckt mit glasigen Kratern, wo Methanwinde feurige Spuren in der Luft hinterlassen.",
          "Unter der Oberfläche liegen Höhlen aus gefrorenem Gas, in denen laut Legenden die ersten Formen von Energie geboren wurden, die zum Denken fähig sind.",
          "👾 Vevi (Vevi Monster)",
          "Vevi ist ein Wesen, das aus den Plasmawirbeln von Zera-13b geboren wurde.",
          "Er ist weder Fleisch noch Metall—sein Körper besteht aus vibrierenden Teilchen, die von einem elektromagnetischen Feld zusammengehalten werden.",
          "Seine Augen leuchten im reflektierten Licht des Sterns Zera-13, und seine Stimme klingt wie das Flüstern des Neonwindes.",
          "Vevi verließ seine Welt, als der Protostern zu verblassen begann. Er reiste durch intergalaktische Leeren, geleitet vom Instinkt, nach neuer Energie zu suchen.",
          "Jetzt wandert er durch Welten und trägt ein Teilchen des ursprünglichen Lichts von Zera-13b mit sich.",
          "Das Leuchten bekam er vom Planeten",
          "Er hat keine Beine—weil der Planet enorme Schwerkraft hat und er einfach schwebt",
          "Er kommuniziert (oder macht eher Geräusche), ähnlich den akustischen Wellen von Delfinen, Walen und Orcas.",
          "Seine Sprache heißt UFOnic",
        ],
      },
      "baddy-sub": {
        title: "Baddy Sub",
        excerpt: "Baddy Sub ist ein Wesen aus dem frühen Universum, geboren in Sub Zone, einer seltenen Region des Weltraums mit hoher Materiedichte.",
        metadata: {
          "Objektname": "Sub Zone (SUB-Z)",
          "Objekttyp": "Protocluster / Galaxienbildungsregion",
          "Epoche": "~200–300 Millionen Jahre nach dem Urknall",
          "Rotverschiebung": "z ≈ 14–15",
          "Rektaszension (RA)": "02h 17m 43s",
          "Deklination (Dec)": "−04° 12′ 09″",
        },
        content: [
          "Baddy Sub Daten",
          "Langer, dünner, länglicher Körper mit zwei unteren Gliedmaßen unten und drei Augen auf ausgedehnten Formen oben",
          "Er hat keinen Mund.",
          "Es gibt auch zwei obere dünne Gliedmaßen, die als Arme interpretiert werden können.",
          "Zwei Finger an jeder Gliedmaße.",
          "Der gesamte Körper ähnelt einem Ast",
          "Haut hat eine glatte matte Struktur",
          "Farbe ist grünlich-braun (Pigmentierung)",
          "Kann die Farbe je nach Umgebung wie ein Chamäleon ändern.",
          "Beschreibung des Planeten, auf dem Baddy Sub geboren wurde:",
          "Sub Zone ist eine seltene Region des frühen Universums mit hoher Materiedichte, wo die ersten galaktischen Strukturen zu entstehen begannen. Beobachtungen deuten auf intensive Wechselwirkungen von Urgas, Strahlung und Gravitationswellen hin. In der Region wurden instabile Signalpattern und anomale Resonanzaktivität aufgezeichnet, untypisch für typische protogalaktische Regionen.",
          "Wissenschaftliche Bedeutung:",
          "Sub Zone gilt als Schlüsselobjekt für die Erforschung der frühen Stadien der Galaxienbildung, der Signalausbreitung im jungen Universum und des Übergangs von chaotischen Strahlungsfeldern zu strukturierten kosmischen Systemen.",
          "Status:",
          "Klassifiziert als ungelöste Bildungsregion. Weitere Forschung erforderlich.",
        ],
      },
    },
  },

  // FAQ
  faq: {
    title: "Häufig Gestellte Fragen",
    subtitle: "Alles, was Sie über VEVI wissen müssen",
    questions: [
      {
        question: "Arbeiten Sie nur mit Stimmen?",
        answer: "Ja — wir ersetzen Ihre Stimme so, dass sie in einer anderen Sprache klingt und dabei natürlich und authentisch bleibt."
      },
      {
        question: "Zahle ich vorher oder nachher?",
        answer: "Nachher. Sie hören zuerst das Ergebnis, dann bezahlen Sie."
      },
      {
        question: "Rückerstattungen?",
        answer: "Nicht erforderlich — Sie bezahlen nur, wenn Sie mit dem Ergebnis zufrieden sind."
      },
      {
        question: "Video länger als 5 Minuten?",
        answer: "Kein Problem. Fragen Sie unseren KI-Assistenten im Online-Chat nach Anweisungen."
      },
      {
        question: "Kann ich eine andere Stimme wählen?",
        answer: "Nein — wir klonen nur Ihre eigene Stimme."
      },
      {
        question: "Mindestzahlung?",
        answer: "Ab $0.50."
      },
      {
        question: "Wie erhalte ich mein Video?",
        answer: "Sofortiger Download in Ihrem Browser + Kopie an Ihre E-Mail nach Zahlung."
      },
      {
        question: "Rabatte für große Bestellungen?",
        answer: "Ja — kontaktieren Sie unseren KI-Assistenten im Online-Chat."
      },
      {
        question: "Antwort nicht gefunden?",
        answer: "Fragen Sie unseren KI-Assistenten im Online-Chat — wir helfen Ihnen gerne."
      },
      {
        question: "Nicht unterstütztes Format?",
        answer: "Verwenden Sie einen Konverter oder erhalten Sie schnelle Hilfe von unserem KI-Assistenten im Online-Chat."
      },
      {
        question: "Mein Video enthält spezifische Begriffe, die korrekt ausgesprochen werden müssen. Kann ich das kontrollieren?",
        answer: "Ja — schreiben Sie einfach unserem KI-Assistenten im Online-Chat, und wir senden Ihnen Anweisungen, wie Sie bestimmte Begriffe markieren oder beibehalten können (z. B. sie auf Englisch belassen)."
      },
      {
        question: "Ich habe meine E-Mail nicht erhalten. Was soll ich tun?",
        answer: "Die Verarbeitungszeit kann aufgrund des Warteschlangenvolumens variieren. Keine Sorge — Ihre Datei ist sicher. Sie erhalten entweder eine Benachrichtigung oder einen direkten Download-Link, sobald sie fertig ist."
      }
    ]
  }
};
